import { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Table, Input } from "reactstrap";
import UsersTableBody from "./UsersTableBody";
import { Btn, H4, H5 } from "../../../AbstractElements";
import CreateUserModal from "./CreateUserModal";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";
import ReactPaginate from 'react-paginate';

interface UsersTableBodyProps {
  users: any,
  setUsers: (users: any) => void
}

const UsersTable: React.FC<UsersTableBodyProps> = ({ users = [], setUsers }) => {
  const [createUserModal, setCreateUserModal] = useState(false)
  const user = useAppSelector(state => state.user)

  const [perPage, setPerPage] = useState(5);
  const [userItems, setUserItems] = useState<any>([]);
  const [userOffset, setUserOffset] = useState(0);
  const [userPageCount, setUserPageCount] = useState(0);

  useEffect(() => {
    const endUserOffset = userOffset + perPage;
    setUserItems(users.slice(userOffset, endUserOffset))
    setUserPageCount(Math.ceil(users.length / perPage))
  }, [perPage, userOffset, users])

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * perPage) % users.length;
    setUserOffset(newOffset);
  }

  const handleChangePerPage = (e: any) => {
    setPerPage(parseInt(e.target.value))
  }

  return (
    <Col xl="12" className="">
      <Card>
        <CardHeader className={"card-no-border pb-0"}>
          <div className={`header-top`}>
            <H4>{"Clinicians Table"}</H4>
            {user.role === "admin" && <Btn color="primary" onClick={() => setCreateUserModal(true)}>New Clinician</Btn>}
          </div>
        </CardHeader>
        <CardBody className="pt-0 projects px-0">
          <div className="dataTables_wrapper">
            <div className="table-responsive theme-scrollbar">
              <Table className="table display dataTable no-footer" id="selling-product">
                <thead>
                  <tr>
                    <th>{"No"}</th>
                    <th>{"First Name"}</th>
                    <th>{"Last Name"}</th>
                    <th>{"Joined at"}</th>
                    <th>{"Email"}</th>
                    <th>{"Role"}</th>
                    <th>{"Status"}</th>
                    <th>{"Total Reports"}</th>
                    <th className="text-center">{"Actions"}</th>
                  </tr>
                </thead>
                <UsersTableBody users={userItems} setUsers={setUsers} />
              </Table>
            </div>
            <div className=" d-flex justify-content-end align-items-center pagination-container mt-3" style={{ gap: 16 }}>

              <div className="d-flex align-items-center items-per-page" style={{ gap: 8 }}>
                <H5>Per Page : </H5>
                <Input
                  type="number"
                  value={perPage}
                  onChange={(e: any) => handleChangePerPage(e)}
                  style={{ width: 50, textAlign: 'center' }}
                />
              </div>
              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                <div>
                  <ReactPaginate
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={1}
                    pageCount={userPageCount}
                    previousLabel="<"
                    breakLabel="..."
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item page-item-previous"
                    previousLinkClassName="page-link"
                    nextClassName="page-item page-item-next"
                    nextLinkClassName="page-link"
                    breakClassName="page-item page-item-break"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                </div>
              </div>
            </div>
          </div>
        </CardBody>
        <CreateUserModal modal={createUserModal} setModal={setCreateUserModal} users={users} setUsers={setUsers} />

      </Card>
    </Col>
  );
};

export default UsersTable;
